import React from 'react';
import { useLanguage } from '../hooks/useLanguage';
import { GraduationCap, BarChart3, Users, ArrowRight } from 'lucide-react';
export function ServicesSection() {
  const {
    t
  } = useLanguage();
  const icons = [GraduationCap, BarChart3, Users];
  return <section id="services" className="py-20 sm:py-32 bg-white px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-107">
      {/* Line Pattern Background */}
      <div className="absolute inset-0 line-pattern opacity-50 pointer-events-none" data-id="element-108" />

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-109">
        <div className="text-center mb-14 sm:mb-24" data-id="element-110">
          <div className="inline-flex items-center justify-center px-4 py-1.5 rounded-full border border-[#ae6470]/20 bg-[#ae6470]/5 mb-6" data-id="element-111">
            <span className="text-[10px] font-bold text-[#ae6470] uppercase tracking-[0.2em]" data-id="element-112">
              {t.services.label}
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#152c61] tracking-tight" data-id="element-113">
            {t.services.title}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-114">
          {t.services.items.map((service, index) => {
          const Icon = icons[index];
          return <div key={index} className="group relative bg-white rounded-[2rem] p-6 sm:p-10 border border-[#152c61]/5 hover:border-[#ae6470]/20 transition-all duration-500 hover:shadow-[0_8px_30px_rgba(21,44,97,0.04)] overflow-hidden" data-id="element-115">
                {/* Hover Gradient Background */}
                <div className="absolute inset-0 bg-gradient-to-br from-[#fdfbf9] to-white opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-116" />

                {/* Content */}
                <div className="relative z-10 flex flex-col h-full" data-id="element-117">
                  {/* Icon Container */}
                  <div className="w-14 h-14 rounded-2xl bg-[#fdfbf9] border border-[#152c61]/5 flex items-center justify-center mb-8 group-hover:scale-110 group-hover:border-[#ae6470]/20 transition-all duration-500" data-id="element-118">
                    <Icon className="w-6 h-6 text-[#ae6470]" strokeWidth={1.5} data-id="element-119" />
                  </div>

                  <h3 className="text-xl font-bold text-[#152c61] mb-4 group-hover:text-[#ae6470] transition-colors duration-300" data-id="element-120">
                    {service.title}
                  </h3>

                  <p className="text-[#152c61]/60 leading-relaxed font-light text-base mb-8" data-id="element-121">
                    {service.description}
                  </p>

                  <div className="mt-auto pt-6 border-t border-[#152c61]/5 flex items-center text-[11px] font-semibold text-[#152c61]/40 uppercase tracking-wider group-hover:text-[#ae6470] transition-colors" data-id="element-122">
                    {t.services.label === 'Was ich anbiete' ? 'Mehr erfahren' : 'Learn more'}
                    <ArrowRight className="ml-2 w-3 h-3 group-hover:translate-x-1 transition-transform" data-id="element-123" />
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}